/**
 * HelpAiEntry — entrée « Demander à l'IA » en tête des résultats (HELP-DRAWER §7.1).
 * Violette (token `--ai`). N'est rendue QUE lorsque l'IA est réellement
 * déclenchable (requête en forme de question, ≥ seuil) — sinon un indice discret
 * non cliquable la remplace (cf. HelpSearchView), pour ne pas exposer un contrôle
 * grisé qui ressemblerait à un bug.
 */

import { useTranslation } from 'react-i18next'
import { CornerDownLeft, Sparkles } from 'lucide-react'

import { cn } from '../../lib/utils'
import { Kbd } from '../ui/kbd'

export function HelpAiEntry({
    query,
    active,
    onTrigger,
    onHover,
    buttonRef,
}: {
    query: string
    active: boolean
    onTrigger: () => void
    onHover: () => void
    buttonRef: (el: HTMLButtonElement | null) => void
}) {
    const { t } = useTranslation()
    return (
        <button
            type="button"
            ref={buttonRef}
            onClick={onTrigger}
            onMouseEnter={onHover}
            className={cn(
                'flex w-full items-center gap-2.5 rounded-xl border border-ai/30 bg-ai/10 px-4 py-3 text-left text-ai transition-colors hover:bg-ai/15 motion-reduce:transition-none',
                active && 'ring-2 ring-ai/60',
            )}
        >
            <Sparkles className="h-4 w-4 shrink-0" />
            <span className="min-w-0 flex-1 truncate text-sm font-medium">
                {t('help.search.askAi', { query })}
            </span>
            <Kbd className="border-ai/30 bg-ai/10 text-ai">
                <CornerDownLeft className="h-3 w-3" />
            </Kbd>
        </button>
    )
}
